import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../data/content';
export function QuoteBanner() {
  return <section className="relative w-full overflow-hidden" data-id="element-118" data-mp="22sznznkn1rid">
      <img src={images.quote} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-119" data-mp="2gtacwl2e0w0w" />
      <div className="absolute inset-0 bg-ink/65" aria-hidden="true" data-id="element-120" data-mp="2buz48dntwrk9" />
      <motion.blockquote initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.4
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 sm:py-28" data-id="element-121" data-mp="1o43edm2xo6fn">
        <p className="font-display text-3xl font-medium leading-tight text-cream sm:text-4xl lg:text-5xl" data-id="element-122" data-mp="1t2wu7l5p09iz">
          “Tu cuerpo puede cambiar a cualquier edad. Solo necesita el movimiento
          correcto.”
        </p>
        <footer className="mt-6 text-lg leading-relaxed text-cream/85 sm:text-xl" data-id="element-123" data-mp="10er7wtyzqch1">
          No se trata de sufrir ni de volverse atleta. Se trata de volver a conectar con
          tu cuerpo, de a poco, con amor y constancia.
        </footer>
      </motion.blockquote>
    </section>;
}